import useDimensions from './useDimensions';
import { BREAKPOINTS } from '@/shared/styles/constants';

const useBreakpoint = () => {
  const { width, height } = useDimensions();

  return {
    isDesktop: width >= BREAKPOINTS.DESKTOP,
    isLargeDesktop: width >= BREAKPOINTS.LARGE_DESKTOP,
    isMobile: width < BREAKPOINTS.DESKTOP,
    width,
    height,
  };
};

export default useBreakpoint;
